import { c as _c } from "react/compiler-runtime";
import type { KeyWith } from '@/lib/piano/keyboard';
import type { MeasuredKeyRequirements } from '@/lib/piano/touch-design/measured-key.requirements';
import { useMeasuredKeyFromStore } from '../store/use-measure-store';
import { useKeyMeasurementsHelpers } from './use-key-measurements-helpers';
import { useKeyboard } from './use-keyboard';
import { useMemo } from 'react';
export const useMeasuredKey = keyNumber => {
  const $ = _c(11);
  const {
    computeKeyMeasurements
  } = useKeyMeasurementsHelpers();
  const {
    keyboard
  } = useKeyboard();
  const keyIndex = keyNumber - 1;
  let t0;
  if ($[0] !== keyNumber || $[1] !== keyboard) {
    t0 = keyboard.getKeyByNumber(keyNumber);
    $[0] = keyNumber;
    $[1] = keyboard;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const key = t0;
  const keyMeasures = useMeasuredKeyFromStore(keyIndex);
  let t1;
  bb0: {
    if (key !== undefined && keyMeasures !== undefined) {
      let t2;
      if ($[3] !== computeKeyMeasurements || $[4] !== keyMeasures) {
        t2 = computeKeyMeasurements(keyMeasures);
        $[3] = computeKeyMeasurements;
        $[4] = keyMeasures;
        $[5] = t2;
      } else {
        t2 = $[5];
      }
      let t3;
      if ($[6] !== key || $[7] !== t2) {
        t3 = {
          ...key,
          payload: t2
        };
        $[6] = key;
        $[7] = t2;
        $[8] = t3;
      } else {
        t3 = $[8];
      }
      t1 = t3;
      break bb0;
    }
    t1 = undefined;
  }
  const measuredKey = t1;
  let t2;
  if ($[9] !== measuredKey) {
    t2 = {
      measuredKey
    };
    $[9] = measuredKey;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};